export const SERVER_AI_URL = import.meta.env.VITE_SERVER_AI_URL;
export const APP_URL = import.meta.env.VITE_APP_URL;
export const WEBSITE_URL = import.meta.env.VITE_WEBSITE_URL;
export const DATAFEED_API = import.meta.env.VITE_DATAFEED_API;
export const CANNY_BOARD_TOKEN = import.meta.env.VITE_CANNY_BOARD_TOKEN;
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY;